module.exports = __webpack_public_path__ + "static/media/needle.422eebea.png";